export const DefferedListData = [
   {
    disputeId: "DSP-5001",
    id: 1,
    referenceNo: "REF-930401",
    customerName: "Anil Rai",
    accountNumber: "1010101010",
    branchName: "New Baneshwor",
    disputeType: "ATM Withdrawal Issue",
    transactionDate: "2025-11-01",
    initiatedDate: "2025-11-02",
    deferredDate: "2025-11-04",
    amount: 15000,
    status: "Deferred",
    remarks: "Waiting for customer response",
    assignedTo: "officer01",
  },
  {
    disputeId: "DSP-5002",
    id: 2,
    referenceNo: "REF-930402",
    customerName: "Sushma Lama",
    accountNumber: "2020202020",
    branchName: "Kalimati",
    disputeType: "POS Transaction Failure",
    transactionDate: "2025-11-02",
    initiatedDate: "2025-11-03",
    deferredDate: "2025-11-05",
    amount: 8000,
    status: "Deferred",
    remarks: "Pending merchant confirmation",
    assignedTo: "officer02",
  },
  {
    disputeId: "DSP-5003",
    id: 3,
    referenceNo: "REF-930403",
    customerName: "Ramesh Thapa",
    accountNumber: "3030303030",
    branchName: "Tripureshwor",
    disputeType: "Fund Transfer Delay",
    transactionDate: "2025-11-01",
    initiatedDate: "2025-11-02",
    deferredDate: "2025-11-06",
    amount: 22000,
    status: "Deferred",
    remarks: "Inter-bank verification required",
    assignedTo: "officer03",
  },
  {
    disputeId: "DSP-5004",
    id: 4,
    referenceNo: "REF-930404",
    customerName: "Nisha Shrestha",
    accountNumber: "4040404040",
    branchName: "Jawalakhel",
    disputeType: "UPI Transaction Issue",
    transactionDate: "2025-11-03",
    initiatedDate: "2025-11-04",
    deferredDate: "2025-11-07",
    amount: 4000,
    status: "Deferred",
    remarks: "UPI gateway logs not yet received",
    assignedTo: "officer01",
  },
  {
    disputeId: "DSP-5005",
    id: 5,
    referenceNo: "REF-930405",
    customerName: "Bibek Karki",
    accountNumber: "5050505050",
    branchName: "Thamel",
    disputeType: "Cheque Cleared Incorrectly",
    transactionDate: "2025-11-01",
    initiatedDate: "2025-11-02",
    deferredDate: "2025-11-05",
    amount: 50000,
    status: "Deferred",
    remarks: "Pending reconciliation from accounting",
    assignedTo: "officer02",
  },
]